import { AsyncPipe, NgIf } from '@angular/common';
import { Component, ContentChild, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { BehaviorSubject, Subscription, tap } from 'rxjs';
import { LoadingService } from 'services/loading.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
  isActive = new BehaviorSubject<boolean>(true);
  subscription?: Subscription;

  @Input()
  detectRouteTransitions = false;

  @ContentChild('loader')
  customLoadingIndicator: TemplateRef<any> | null = null;

  constructor(
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.subscription = this.loadingService.loading$.subscribe((isLoading) => {
      this.isActive.next(isLoading);
    });
  }

  ngOnInit() {
    if (this.detectRouteTransitions) {
      this.router.events
        .pipe(
          tap((event) => {
            if (event instanceof NavigationStart) {
              this.loadingService.loadingOn('navigation');
            } else if (event instanceof NavigationEnd) {
              this.loadingService.loadingOff('navigation');
            }
          })
        )
        .subscribe();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
